import { useI18n } from "../context/I18nContext";

export default function LangToggle({ className = "" }) {
  const { lang, toggle } = useI18n();
  return (
    <button
      onClick={toggle}
      data-testid="lang-toggle"
      className={`text-xs font-mono uppercase tracking-[0.2em] border border-[#282C33] px-3 py-1.5 hover:border-[#00A896] transition-colors flex items-center gap-1 ${className}`}
      aria-label="Toggle language"
    >
      <span className={lang === "en" ? "text-[#00A896]" : "text-[#8C939D]"}>EN</span>
      <span className="text-[#282C33]">/</span>
      <span className={lang === "ta" ? "text-[#00A896]" : "text-[#8C939D]"}>த</span>
    </button>
  );
}
